webpackJsonp([107119748094653],{

/***/ 123:
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = [{
		type: 'image',
		filename: '001-tumblr_n3bx56kEFp1twddx5o1_1280.jpg'
	}, {
		type: 'image',
		filename: '003-tumblr_mowa9jYvxh1rf5r4qo1_1280.jpg'
	}, {
		type: 'image',
		filename: '004-tumblr_nb6fp1VAIv1rp9kgfo1_500.gif'
	}, {
		type: 'image',
		filename: '010-tumblr_nd6z630LxU1qzh73lo1_1280.jpg'
	}, {
		type: 'image',
		filename: '012-tumblr_n41wzsYbh61r6bf6qo1_1280.jpg'
	}, {
		type: 'text',
		body: 'I don’t know what she wants, but it has something to do with me. Like a man possessed I waste no time in over-thinking, re-thinking and finally under-thinking the whole endeavor. I strip the girth of her want to meager nothing and wait to fuck it all up. It should be great for me. That it had come at such a crossroads in both my year and life is no coincidence and I fear that greatness can only be achieved when our moments and opportunities parallel our own gravity of action. Further, I fear this threatens to quantify our greatness as chance and further still, I fear greatness to be so polished by mood that there is nothing great to be found in anything at all.'
	}, {
		type: 'image',
		filename: '014-tumblr_lzcwd4OR6F1qez43mo1_500.jpg'
	}, {
		type: 'image',
		filename: '016-tumblr_mzeu81jJaZ1s9jctjo1_500.jpg'
	}, {
		type: 'image',
		filename: '018-tumblr_n1hhz10HU91qe0lqqo1_1280.jpg'
	}, {
		type: 'image',
		filename: '021-tumblr_mo6zvedf0i1qiisr5o1_1280.jpg'
	}, {
		type: 'image',
		filename: '023-tumblr_n3rrbvkVhC1qaoqu9o1_500.jpg'
	}, {
		type: 'image',
		filename: '024-tumblr_mzptq1Il8T1qanxjro1_1280.png'
	}, {
		type: 'image',
		filename: '026-tumblr_nfez1jgj1X1u0f9qvo1_1280.png'
	}, {
		type: 'image',
		filename: '027-tumblr_ncdji21Sem1qe1h5no2_500.gif'
	}, {
		type: 'image',
		filename: '029-tumblr_mi8c5qC66o1ritkdwo1_500.png'
	}, {
		type: 'image',
		filename: '035-tumblr_n0acl0aeBQ1s46c7no1_1280.jpg'
	}, {
		type: 'image',
		filename: '036-tumblr_mm7zs8THF21s31alto1_500.jpg'
	}, {
		type: 'image',
		filename: '037-tumblr_najw049cRB1rclfizo1_1280.jpg'
	}, {
		type: 'image',
		filename: '041-tumblr_n3yydm1uHb1rpowflo1_1280.jpg'
	}, {
		type: 'image',
		filename: '042-tumblr_n3velmCrU01s80eheo1_1280.jpg'
	}, {
		type: 'image',
		filename: '043-tumblr_n23euiisI41qz7lxdo1_1280.jpg'
	}, {
		type: 'image',
		filename: '044-tumblr_ndr6l87xRT1r14mf3o1_1280.jpg'
	}, {
		type: 'image',
		filename: '045-tumblr_n1dlcwz5v81s25qz6o1_1280.jpg'
	}, {
		type: 'image',
		filename: '049-tumblr_mr341hoQNp1r05jkho1_1280.jpg'
	}, {
		type: 'image',
		filename: '053-tumblr_miux51r28n1rd5ejfo1_1280.jpg'
	}, {
		type: 'image',
		filename: '059-tumblr_nc3ssztFmi1qaqv2ro1_500.jpg'
	}, {
		type: 'text',
		body: 'Over and over again these heavier years will mount and in quick succession and I’ll be just as fetal as my first and last days. So it is not our experience or qualifications which render us able but our surroundings and timing. In this, the Two Thousand and Thirteenth Year of Our Lord, I learned how to long again. Where it began to wane or even finally dispersed, I couldn’t even tell you. It might have been a trade off in learning how to achieve in the year previous and was probably necessary in my grand narrative. I’ve found hard work and dedication will produce feat, not always in the wake of desire. It was also discovered I am no man but myself and this is not a consequence or a short-coming but rather an invigoration and talent. Now it is important to recognize craving is not bound within a fabric of achievement, necessarily, and can be entirely the opposite. Triumph in the face of lust will be the theme of the new year. As will extending my thirst for knowledge beyond immediacy. More reading and appreciation and indulgence to come. In homage to the men and women who’ve helped me come to this podium, I have to thank everyone who I’ve ever thanked as well as the four or five women with whom I’ve shared meaningful, meaningless and plan- to-mean somethings over the past year. I have to confess a lack of attention to duty (lol) and can only imagine the opinions of my friends this year. It could have been the smashing of the phone, the intrinsic need to pathologically lie and displace truth, and the constant need for self-reassurance and aggrandisation in the face of self; it could be anything. But I am trying to improve so there’s that. To the women I won’t wish Merry Christmas I’m sorry and I don’t love you. I find it hard to say goodbye for anytime at all and refuse to acknowledge infinity so I will still keep you in mind from time to time. I peg myself as the odd cog for not being more invested in you and your heads and the ways they work. I find you all attractive in your own ways and wish to speed for a womanly culmination of you all, whom I still search for. I probably could’ve made a point to tell you each when I knew for certain I wouldn’t speak to you in the new year. For some it was the silence that didn’t end, even after the conversations began again. For some it was the distance between the passion of our first and latest fuck. For most of you it was something. I don’t lust for women. I lust for waking next to someone without guilt (see:resentment). To Elenore, I only saw our shared longings as so the next morning in sobriety and am breathless that you don’t have facebook. No one I know has your number, and if you are reading this we should talk. If you’re in town don’t be a stranger. As it seems, I am coming to a point where I must change the world, at least challenge it. 2014 seems right due to lack of fate and girth of necessity. I found vice this year not in substance but abuse. It’s not things but ideas and opinions that get me hard and I know this will never be replaced. It will be important to find ways to use this outside of drinking, smoking and other things. This will be my last year of college, I’m sure, and I can’t imagine it will be less than ten years before I go back. Enough about that. I hope to find more solace and more importance in family and friends. I find it hard and struggle to care, when something so present as promise of success or yearning come to a foreground. And so what to do? — Attempt to find reasons beyond those of loss with which to love. In all this I’ll probably still be an asshole, who can’t find reason to give a fuck. But it will be from a smaller hill in a bigger city. Take what’s urs/'
	}, {
		type: 'image',
		filename: '061-tumblr_myuorqS0DC1qb8xvxo1_1280.jpg'
	}, {
		type: 'image',
		filename: '062-tumblr_mtcumlcgZE1qerok2o1_1280.jpg'
	}, {
		type: 'image',
		filename: '064-tumblr_ncqvzkt5ba1qgr6ibo1_1280.gif'
	}, {
		type: 'image',
		filename: '066-tumblr_nd5l3cCFYz1r8k1cmo1_1280.jpg'
	}, {
		type: 'image',
		filename: '067-tumblr_m0aanaAjXH1qjm0dlo1_1280.jpg'
	}, {
		type: 'image',
		filename: '068-tumblr_n5hfxcfrt01redhwqo1_1280.jpg'
	}, {
		type: 'image',
		filename: '069-tumblr_n772s96PX11rionq1o1_1280.jpg'
	}, {
		type: 'image',
		filename: '070-tumblr_n3a274KNPU1qfvjreo1_1280.jpg'
	}, {
		type: 'image',
		filename: '076-tumblr_mp9ifrFX281rbpuiqo1_1280.jpg'
	}, {
		type: 'image',
		filename: '077-tumblr_mzl44vZ0mQ1qce2t7o1_1280.jpg'
	}, {
		type: 'image',
		filename: '079-tumblr_mr1ek5Pz3w1r3h68so1_1280.jpg'
	}, {
		type: 'image',
		filename: '081-tumblr_n2k3f10M7o1tv8f4lo1_1280.jpg'
	}, {
		type: 'image',
		filename: '082-tumblr_n4ss2p4HbH1qal51bo1_1280.jpg'
	}, {
		type: 'image',
		filename: '086-tumblr_n3mokdd0Z41r1xjp6o1_1280.jpg'
	}, {
		type: 'image',
		filename: '090-tumblr_mkn3j8A2nL1qeh05xo1_1280.jpg'
	}, {
		type: 'image',
		filename: '091-tumblr_m6krvbgdAy1r8esfco1_1280.jpg'
	}, {
		type: 'image',
		filename: '092-tumblr_mo6fa6Blhk1qaxe9co1_1280.jpg'
	}, {
		type: 'image',
		filename: '094-tumblr_mibeg0TTHU1qbvizto1_1280.jpg'
	}, {
		type: 'image',
		filename: '099-tumblr_n7oo8l10bj1soz1uvo1_1280.jpg'
	}, {
		type: 'image',
		filename: '100-tumblr_mj0pjetDRL1qf8gqxo1_1280.jpg'
	}, {
		type: 'image',
		filename: '103-tumblr_n8luevSk8c1rq18dno1_1280.jpg'
	}, {
		type: 'image',
		filename: '105-tumblr_ll93z00rxA1qbvog8o1_500.jpg'
	}, {
		type: 'image',
		filename: '107-tumblr_n6k00cTk8i1se8jyso1_1280.jpg'
	}, {
		type: 'image',
		filename: '108-tumblr_n3n5th5mCO1qfb2vso1_1280.png'
	}, {
		type: 'image',
		filename: '109-tumblr_n3n5th5mCO1qfb2vso1_1280.png'
	}, {
		type: 'image',
		filename: '110-tumblr_n3p8wj6Oy91rwkvi9o1_1280.jpg'
	}, {
		type: 'image',
		filename: '112-tumblr_n0qp0pwDqw1qdq5dlo1_500.png'
	}, {
		type: 'image',
		filename: '115-tumblr_n340p42JGl1rp9ywno1_500.jpg'
	}, {
		type: 'image',
		filename: '118-tumblr_mrwkqzmfAO1r3mab2o1_1280.jpg'
	}, {
		type: 'image',
		filename: '121-tumblr_n0yofkKyX41qb4hiyo1_1280.jpg'
	}, {
		type: 'image',
		filename: '123-tumblr_mbkjwlI3Na1qfu80qo1_1280.jpg'
	}, {
		type: 'image',
		filename: '124-tumblr_ma92c9Rflp1qd07evo1_500.gif'
	}, {
		type: 'image',
		filename: '126-tumblr_n0jmffCUUt1s3xtdto1_1280.jpg'
	}, {
		type: 'image',
		filename: '129-tumblr_n0ge47mjCz1r14mf3o1_1280.jpg'
	}, {
		type: 'image',
		filename: '131-tumblr_mfxthiw4kv1rwvf68o1_1280.png'
	}, {
		type: 'image',
		filename: '132-tumblr_mlhbk1Mw191r77ccao1_r1_1280.jpg'
	}, {
		type: 'image',
		filename: '134-tumblr_n08bp2cmyR1r98xpoo1_500.gif'
	}, {
		type: 'image',
		filename: '135-tumblr_n089k0KITe1r14mf3o1_500.jpg'
	}, {
		type: 'image',
		filename: '136-tumblr_magd3kvIzw1r3055wo1_500.jpg'
	}, {
		type: 'image',
		filename: '137-tumblr_mfsyhk9FET1rlrs4to1_1280.jpg'
	}, {
		type: 'image',
		filename: '139-tumblr_mw49q3CkfT1r1e5zeo1_1280.jpg'
	}, {
		type: 'image',
		filename: '143-tumblr_mu0523TEPX1s2p87so1_1280.jpg'
	}, {
		type: 'image',
		filename: '144-tumblr_m750cgtlrI1qaae98o1_1280.jpg'
	}, {
		type: 'image',
		filename: '147-tumblr_myj7ndtzkF1rpowflo1_1280.jpg'
	}, {
		type: 'image',
		filename: '150-tumblr_mvnqf2hvm41rz4u3so1_1280.jpg'
	}, {
		type: 'image',
		filename: '151-tumblr_mtawpxkjBS1qgmu5uo1_1280.jpg'
	}, {
		type: 'image',
		filename: '152-tumblr_mim6kzgbx81rwvf68o1_1280.jpg'
	}, {
		type: 'image',
		filename: '153-tumblr_my1cufSKnV1qcoq03o1_1280.jpg'
	}, {
		type: 'image',
		filename: '154-tumblr_mrq22bOQRz1rd3xoko1_1280.jpg'
	}, {
		type: 'image',
		filename: '158-tumblr_m9me93QW511rd3xoko1_1280.jpg'
	}, {
		type: 'image',
		filename: '160-tumblr_mt8dnqAPPI1rkh96wo1_1280.jpg'
	}, {
		type: 'text',
		body: 'Me no study\nMe no care\nMe go marry\nA millionare\nIf he die\nMe no cry\nMe go marry\nAnother guy'
	}, {
		type: 'image',
		filename: '161-tumblr_mx92m8gib81rn12fjo1_500.jpg'
	}, {
		type: 'image',
		filename: '162-tumblr_mwc36mr4jt1r961bco1_500.jpg'
	}, {
		type: 'image',
		filename: '167-tumblr_mwwvniUakq1qgr6ibo1_1280.jpg'
	}, {
		type: 'image',
		filename: '170-tumblr_mvm3pdxhu11qa3061o1_1280.jpg'
	}, {
		type: 'image',
		filename: '172-tumblr_mr42yt11k01qksk1yo1_r1_1280.jpg'
	}, {
		type: 'image',
		filename: '175-tumblr_mvxuq9yRBO1riwr5vo1_1280.jpg'
	}, {
		type: 'image',
		filename: '177-tumblr_lltdxxy9wt1qad56lo1_1280.jpg'
	}, {
		type: 'text',
		body: 'It hasn’t been 11:11 in a few billi years so just stfu'
	}];

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(5);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ramda = __webpack_require__(38);
	
	var _ramda2 = _interopRequireDefault(_ramda);
	
	var _helpers = __webpack_require__(33);
	
	var _posts = __webpack_require__(123);
	
	var _posts2 = _interopRequireDefault(_posts);
	
	var _cartier = __webpack_require__(808);
	
	var _cartier2 = _interopRequireDefault(_cartier);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import cartier from './videos'
	
	/**
	 * Post
	 */
	
	var Post = function (_React$Component) {
		_inherits(Post, _React$Component);
	
		function Post(props) {
			_classCallCheck(this, Post);
	
			var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
			_this.registerRef = _this.registerRef.bind(_this);
			_this.postLoaded = _this.postLoaded.bind(_this);
			return _this;
		}
	
		Post.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
			return false;
		};
	
		Post.prototype.componentDidMount = function componentDidMount() {
			if (this.element.tagName.toLowerCase() === 'img') {
				if (this.element.complete) this.postLoaded();
			} else {
				this.postLoaded();
			}
		};
	
		Post.prototype.registerRef = function registerRef(element) {
			this.element = element;
		};
	
		Post.prototype.postLoaded = function postLoaded() {
			this.props.addToLoadedCount(this.props.index);
		};
	
		Post.prototype.render = function render() {
	
			var classNames = ['cartier__post'];
			classNames.push('cartier__post--' + this.props.type);
			if (this.props.type === 'image') {
				return _react2.default.createElement(
					'div',
					{ className: (0, _helpers.cn)(classNames) },
					_react2.default.createElement('img', {
						ref: this.registerRef,
						onLoad: this.postLoaded,
						onError: this.postLoaded,
						alt: 'littlebabyangel',
						src: 'https://luckyme-public.s3.amazonaws.com/littlebabyangel/cartier-tumblr/' + this.props.filename
					})
				);
			}
			if (this.props.type === 'text') {
				this.postLoaded();
				return _react2.default.createElement('div', { ref: this.registerRef, className: (0, _helpers.cn)(classNames), dangerouslySetInnerHTML: { __html: (0, _helpers.makePostText)(this.props.body) } });
			}
			return null;
		};
	
		return Post;
	}(_react2.default.Component);
	
	Post.propTypes = {
		// title: PropTypes.string
	};
	
	Post.defaultProps = {}
	// title: 'My Title'
	
	
	/**
	 * Cartier
	 */
	
	;
	var Cartier = function (_React$Component2) {
		_inherits(Cartier, _React$Component2);
	
		function Cartier(props) {
			_classCallCheck(this, Cartier);
	
			var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this, props));
	
			_this2.debounceTimer = null;
	
			_this2.state = {
				postsToShow: 15,
				complete: false
			};
			_this2.addToLoadedCount = _this2.addToLoadedCount.bind(_this2);
			_this2.onVideoPlay = _this2.onVideoPlay.bind(_this2);
			_this2.playVideo = _this2.playVideo.bind(_this2);
	
			_this2.loaded = 0;
			_this2.watchScroll = _this2.watchScroll.bind(_this2);
			_this2.calculate();
			return _this2;
		}
	
		Cartier.prototype.componentDidMount = function componentDidMount() {
			document.documentElement.scrollTop = 0;
			window.addEventListener('scroll', this.watchScroll);
			this.calculate();
			this.loaded = 0;
			this.playVideo();
		};
	
		Cartier.prototype.componentWillUnmount = function componentWillUnmount() {
			window.removeEventListener('scroll', this.watchScroll);
		};
	
		Cartier.prototype.onVideoPlay = function onVideoPlay() {
			this.setState({
				needsInteraction: false
			});
			window.seeThru.create(this.video);
		};
	
		Cartier.prototype.playVideo = function playVideo() {
			var _this3 = this;
	
			this.video.play().then(function () {}).catch(function (err) {
				_this3.setState({
					needsInteraction: true
				});
			});
		};
	
		Cartier.prototype.calculate = function calculate() {
			var _this4 = this;
	
			clearTimeout(this.debounceTimer);
			this.debounceTimer = setTimeout(function () {
				var body = { document: document };
				var html = document.documentElement;
				_this4.windowHeight = window.innerHeight || html.clientHeight || body.clientHeight;
				_this4.documentHeight = _this4.mainContainer.scrollHeight;
			}, 250);
		};
	
		Cartier.prototype.watchScroll = function watchScroll() {
			if (!this.mainContainer) return;
			var scrollTop = pageYOffset || document.body.scrollTop;
			if (scrollTop + this.windowHeight >= this.mainContainer.scrollHeight - 0.5 * this.windowHeight) {
				var postsToShow = Math.min(this.state.postsToShow + 10, _posts2.default.length);
				var complete = postsToShow === _posts2.default.length;
				this.setState({
					postsToShow: postsToShow,
					complete: complete
				});
			}
			if (scrollTop >= this.mainContainer.scrollHeight) {
				this.props.history.push('/');
			}
		};
	
		Cartier.prototype.addToLoadedCount = function addToLoadedCount() {
			this.loaded += 1;
			if (this.loaded === _posts2.default.length) {
				this.setState({ complete: true });
			}
		};
	
		Cartier.prototype.render = function render() {
			var _this5 = this;
	
			var visiblePosts = _ramda2.default.take(this.state.postsToShow)(_posts2.default);
			var classNames = ['cartier'];
			if (this.state.complete) classNames.push('cartier--complete');
			if (this.state.needsInteraction) classNames.push('needsInteraction');
			return _react2.default.createElement(
				'section',
				{ ref: function ref(element) {
						_this5.mainContainer = element;
					}, className: (0, _helpers.cn)(classNames) },
				_react2.default.createElement(
					'button',
					{ className: 'videoPlay', onClick: this.playVideo },
					_react2.default.createElement('span', null)
				),
				_react2.default.createElement(
					'div',
					{ className: 'videoFrame videoFrame--full videoFrame--alpha' },
					_react2.default.createElement('video', {
						className: 'video--full video--alpha',
						onPlay: this.onVideoPlay,
						ref: function ref(element) {
							_this5.video = element;
						},
						src: _cartier2.default
					})
				),
				_react2.default.createElement(
					'div',
					{ className: 'cartier__blog' },
					visiblePosts.map(function (p, i) {
						return _react2.default.createElement(Post, _extends({ key: p.body || p.filename, index: i }, p, { addToLoadedCount: _this5.addToLoadedCount }));
					})
				)
			);
		};
	
		return Cartier;
	}(_react2.default.Component);
	
	exports.default = Cartier;
	module.exports = exports['default'];

/***/ }),

/***/ 808:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/cartier.1c1c48be.mp4";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-cartier-js-976d1484fbdb3ae7c944.js